import React, { useEffect, useState } from "react"
import Navbar from "../components/Navbar/Navbar"
// import { mainMenu } from "../components/Navbar/Constants"
import { useNavigate } from "react-router-dom"
import Logo from "../asserts/Logo1.png"

const NavbarContainer = () => {
  const navigate = useNavigate()
  // const pathname  = useLocation()
  return (
    <>
      <div className="w-full flex justify-between items-center md:px-12 px-3">
        <span className="w-16 h-16 md:mr-5">
          <img src={Logo} alt="Logo" />
        </span>
        <div className="flex flex-col">
          <span
            className="md:text-3xl uppercase hover:cursor-pointer"
            onClick={() => {
              navigate("/")
            }}
          >
            Vaishnavi Uchil
          </span>
          <span className="text-xs">You heard it from me</span>
        </div>
        <Navbar />
      </div>
    </>
  )
}

export default NavbarContainer
